import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import OwnerDesk from './workspace/OwnerDesk';

// # OWNER: una única aplicación operativa. Aislar su tema evita que una mejora
// visual cambie el resto del panel, los clientes o sus proyectos publicados.
const deskTheme = createTheme({
  palette: { mode: 'light', primary: { main: '#416848' }, background: { default: '#f6f7f3', paper: '#ffffff' }, text: { primary: '#35452e', secondary: '#8a957f' }, divider: '#e3e8dc' },
  typography: { fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif', button: { textTransform: 'none', fontWeight: 600 } },
  shape: { borderRadius: 10 },
  components: { MuiButton: { defaultProps: { disableElevation: true } }, MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } } },
});
export default function OwnerWorkspace() { return <ThemeProvider theme={deskTheme}><OwnerDesk /></ThemeProvider>; }
